import "./PatientTable.scss";
import { PlusIcon } from "../../../assets/icons-components/Icons";
import SearchInput from "../../../components/SearchInput/SearchInput";
import Buttons from "../../../components/Buttons/Buttons";
import usePatientTable from "./usePatientTable";
import PatientTableRows from "./PatientTableRows";

export default function PatientTable() {
  const {
    rows,
    page,
    rowsPerPage,
    searchQuery,
    totalRows,
    handleView,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSearchChange,
    handleForm,
    formatDuration,
    isLoading,
    fetchError,
    retryFetchPatients,
  } = usePatientTable();

  return (
    <div className="patient-table">
            <div className="patient-table_header">
        <div className="patient-table_header_left">
          <SearchInput
            className="patient-table_header_left_searchbar"
            name="searchQuery"
            placeholder="Search by Patient Name, User Name or Device ID"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
        <div className="patient-table_header_right">
          <Buttons
            text="Add Patient"
            type="button"
            variant="primary"
            fullWidth={false}
            style={{ height: 40 }}
            onClick={handleForm}
            icon={<PlusIcon />}
          />
        </div>
      </div>

      <PatientTableRows
        rows={rows}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onView={handleView}
        formatDuration={formatDuration}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        isLoading={isLoading}
        fetchError={fetchError}
        onRetry={retryFetchPatients}
      />
    </div>
  );
}
